module.exports = __webpack_public_path__ + "img/structural-subdivision-user-cup.eb80f74e.svg";